'use client'

import { AUCTION_TITLE_TRUNCATION_LENGTH } from '@/lib/constants';
import { truncateString } from '@/lib/utils';
import { InfoCircledIcon } from '@radix-ui/react-icons';
import { Flex, Text } from '@radix-ui/themes';
import React from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from "@/app/components/ui/tooltip";

interface Props {
  auctionTitle: string;
}

const PreviewBanner = ({ auctionTitle }: Props) => {
  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger asChild>
        <Flex className="bg-amber-100 rounded-lg px-3 h-8 cursor-pointer" align="center">
          <InfoCircledIcon className="w-4 h-4 mr-2" />
          <Text className="font-medium text-sm">
            {truncateString(auctionTitle, AUCTION_TITLE_TRUNCATION_LENGTH)} - Admin Preview
          </Text>
        </Flex>
      </TooltipTrigger>
      <TooltipContent className="w-80 text-sm">
        This auction has not yet been published. This is a pre-publish view that reflects the current state of the auction, and any changes made in the admin dashboard will appear here.<br /><br />
        Once this auction is published, buyers will see what&apos;s here.
      </TooltipContent>
    </Tooltip>
  );
}

export default PreviewBanner
